import Header from "@/components/Header";
import Hero, { HeroContent, heroDefaults } from "@/components/Hero";
import ValueProposition, { ValuePropositionContent, valuePropositionDefaults } from "@/components/ValueProposition";
import WhoItsFor, { WhoItsForContent, whoItsForDefaults } from "@/components/WhoItsFor";
import GrowthSystemOverview, { GrowthSystemContent, growthSystemDefaults } from "@/components/GrowthSystemOverview";
import Capability, { CapabilityContent, capabilityDefaults } from "@/components/Capability";
import ThinkingBlocks, { ThinkingBlocksContent, thinkingBlocksDefaults } from "@/components/ThinkingBlocks";
import ServicesCompact, { ServicesCompactContent, servicesCompactDefaults } from "@/components/ServicesCompact";
import Industries, { IndustriesContent, industriesDefaults } from "@/components/Industries";
import Proof, { ProofContent, proofDefaults } from "@/components/Proof";
import ClosingCTA, { ClosingCTAContent, closingCTADefaults } from "@/components/ClosingCTA";
import Footer from "@/components/Footer";
import { usePageContent } from "@/hooks/usePageContent";

interface HomepageContent {
  hero: HeroContent;
  valueProposition: ValuePropositionContent;
  whoItsFor: WhoItsForContent;
  growthSystem: GrowthSystemContent;
  capability: CapabilityContent;
  thinkingBlocks: ThinkingBlocksContent;
  servicesCompact: ServicesCompactContent;
  industries: IndustriesContent;
  proof: ProofContent;
  closingCTA: ClosingCTAContent;
}

const fallback: HomepageContent = {
  hero: heroDefaults,
  valueProposition: valuePropositionDefaults,
  whoItsFor: whoItsForDefaults,
  growthSystem: growthSystemDefaults,
  capability: capabilityDefaults,
  thinkingBlocks: thinkingBlocksDefaults,
  servicesCompact: servicesCompactDefaults,
  industries: industriesDefaults,
  proof: proofDefaults,
  closingCTA: closingCTADefaults,
};

const Index = () => {
  const { content } = usePageContent<HomepageContent>("homepage", fallback);

  return (
    <div className="min-h-screen bg-background">
      <Header />
      <main>
        <Hero content={content.hero} />
        <ValueProposition content={content.valueProposition} />
        <WhoItsFor content={content.whoItsFor} />
        <GrowthSystemOverview content={content.growthSystem} />
        <Capability content={content.capability} />
        <ThinkingBlocks content={content.thinkingBlocks} />
        <ServicesCompact content={content.servicesCompact} />
        <Industries content={content.industries} />
        <Proof content={content.proof} />
        <ClosingCTA content={content.closingCTA} />
      </main>
      <Footer />
    </div>
  );
};

export default Index;
